import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestProvider } from '../request/request';
import { ConfigProvider } from '../config/config';
import { StorageProvider } from '../storage-service/storage-service';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { LidProvider } from '../lid-provider/lid-provider';

/*
  Generated class for the NewsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface PagerModel {
  page: string;
  limit: string;
  start: string;
}

export interface NewsListModel {
  id: number;
  title: string;
  imgLink: string;
  formattedDate: string;
}
export interface NewsDetailsModel extends NewsListModel {
  htmlContent: string,
  event?:any
}

export interface MyNewsSearchModel extends PagerModel {
  lid?: number;
}

@Injectable({providedIn:'root'})
export class NewsProvider {

  constructor(
    private request: RequestProvider,
    private lidProvider: LidProvider,
    private strg: StorageProvider,
    private config: ConfigProvider) {
  }

  async getMyNews(rawParams: MyNewsSearchModel, lid?: number) {
    let lidOrg = lid;
    if (typeof lid === "undefined") {
      lidOrg = await this.lidProvider.getLid().then(r => r);
    }
    delete rawParams.lid;
    if (!navigator.onLine) return this.strg.getSaved(Cache.NEWS_KEY).then(r => r);
    else return this.request.getApiSimple<NewsListModel[]>(`user/${lidOrg}/news`, rawParams, 2000, "sportevent").then(r => {
      this.strg.saveData(r, Cache.NEWS_KEY);
      return r;
    }).catch(err => {
      alert(err);
    });
  }

  async getNews(id: number) {
    return this.request.getApiSimple<NewsDetailsModel>(`news/${id}/details`, {}, 2000, "sportevent").catch(err => {
      alert(err);
    })
  }
}
